import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = n => (_pushScopeId("data-v-0ef87f10"), n = n(), _popScopeId(), n);
var _hoisted_1 = {
  id: "container-profile-menu",
  class: "tw-border tw-border-w-secondary tw-rounded tw-flex tw-flex-col tw-justify-between tw-overflow-hidden tw-mb-[50px]"
};
var _hoisted_2 = {
  class: "tw-p-20px"
};
var _hoisted_3 = {
  class: "tw-flex"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "tw-flex tw-flex-col tw-ml-10px tw-justify-center"
};
var _hoisted_6 = ["innerHTML"];
var _hoisted_7 = ["innerHTML"];
var _hoisted_8 = {
  id: "profile-listing-items",
  class: "tw-p-0 tw-mt-30px tw-mb-[50px] tw-pb-[50px]"
};
var _hoisted_9 = ["onMouseover"];
var _hoisted_10 = ["onClick"];
var _hoisted_11 = ["innerHTML"];
var _hoisted_12 = {
  key: 0,
  class: "tw-bg-w-danger/15 tw-size-5 tw-rounded-circle tw-border tw-border-solid tw-border-w-danger tw-p-0 tw-flex tw-items-center tw-justify-center tw-text-w-danger",
  innerHTML: '!'
};
var _hoisted_13 = {
  key: 1,
  class: "tw-text-10 tw-text-white tw-bg-w-primary tw-inline-flex tw-items-center tw-justify-center tw-rounded tw-w-7 tw-h-5 tw-relative"
};
var _hoisted_14 = {
  key: 2,
  class: "tw-text-10 tw-text-white tw-bg-w-primary tw-inline-flex tw-items-center tw-justify-center tw-rounded tw-w-7 tw-h-5 tw-relative"
};
var _hoisted_15 = {
  key: 3,
  class: "tw-text-10 tw-text-white tw-bg-w-primary tw-inline-flex tw-items-center tw-justify-center tw-rounded tw-w-7 tw-h-5 tw-relative"
};
var _hoisted_16 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_icon = _resolveComponent("base-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: _ctx.profileImg,
    height: "77",
    width: "77",
    alt: "profile image"
  }, null, 8 /* PROPS */, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", {
    class: "tw-text-12",
    innerHTML: _ctx.labels.hello
  }, null, 8 /* PROPS */, _hoisted_6), _createElementVNode("h3", {
    class: "tw-text-16 tw-font-medium",
    innerHTML: _ctx.profileName
  }, null, 8 /* PROPS */, _hoisted_7)])]), _createElementVNode("ul", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profilePages, (page, i) => {
    return _openBlock(), _createElementBlock("li", {
      key: i,
      class: _normalizeClass([{
        'active': _ctx.inWhatPage === page.link,
        'disabled tw-opacity-50': (i === 2 || i === 3 || i === 4 || i === 5) && !_ctx.isEmailVerified
      }, "tw-my-20px tw-text-16 tw-flex tw-justify-between"]),
      onMouseover: $event => _ctx.activeHoverOfPage = i,
      onMouseout: _cache[0] || (_cache[0] = $event => _ctx.activeHoverOfPage = null)
    }, [_createElementVNode("span", {
      class: _normalizeClass({
        'tw-cursor-pointer': _ctx.inWhatPage !== page.link
      }),
      onClick: $event => _ctx.customRedirectTo(page.link)
    }, [_createVNode(_component_base_icon, {
      "alt-attribute": "icona menu ".concat(i),
      "icon-name": _ctx.inWhatPage === page.link || _ctx.activeHoverOfPage == i ? page.activeIcon : page.inactiveIcon
    }, null, 8 /* PROPS */, ["alt-attribute", "icon-name"]), _createElementVNode("span", {
      innerHTML: page.text
    }, null, 8 /* PROPS */, _hoisted_11)], 10 /* CLASS, PROPS */, _hoisted_10), i === 0 && !_ctx.isEmailVerified ? (_openBlock(), _createElementBlock("span", _hoisted_12)) : _createCommentVNode("v-if", true), i === 1 && _ctx.favoritesCounter > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.favoritesCounter), 1 /* TEXT */)) : _createCommentVNode("v-if", true), i === 2 && _ctx.requestsCounter > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.requestsCounter), 1 /* TEXT */)) : _createCommentVNode("v-if", true), i === 3 && _ctx.savedSearchesCounter > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.savedSearchesCounter), 1 /* TEXT */)) : _createCommentVNode("v-if", true)], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_9);
  }), 128 /* KEYED_FRAGMENT */))])]), _createElementVNode("div", {
    class: "tw-px-20px tw-py-10px tw-bg-w-cultured tw-cursor-pointer",
    "data-cy": "profile-logout-btn",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    function () {
      return _ctx.logoutUser && _ctx.logoutUser(...arguments);
    })
  }, [_createElementVNode("span", null, [_createVNode(_component_base_icon, {
    "alt-attribute": "icona logout",
    "icon-name": "user_logout_blue.svg"
  }), _createElementVNode("span", {
    class: "tw-text tw-font-medium tw-text-w-primary",
    innerHTML: _ctx.labels.publicAreaLogout
  }, null, 8 /* PROPS */, _hoisted_16)])])]);
}